import React from'react';import PropTypes from'prop-types';import styled from'styled-components';import {useMedia,BREAKPOINTS,Progress,PROGRESS_VARIANT}from'@manulife/mux';import CoBrandingLogo from'../../CoBranding/CoBrandingLogo.js';var PageWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "LoadingPage__PageWrapper",
  componentId: "sc-13n3z6x-0"
})(["display:flex;flex-direction:column;width:100%;height:100%;overflow:hidden;position:relative;flex-grow:1;margin-bottom:-40px;"]);
function LoadingPage(props) {
  var loadingMessage = props.loadingMessage;
  var isMobile = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_1024, "px)")], [true], false);
  return /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(CoBrandingLogo, {
    hideManulife: isMobile
  }), /*#__PURE__*/React.createElement(Progress, {
    isFloating: true,
    variant: PROGRESS_VARIANT.STYLIZED_M,
    message: loadingMessage
  }));
}
process.env.NODE_ENV !== "production" ? LoadingPage.propTypes = {
  loadingMessage: PropTypes.string
} : void 0;
LoadingPage.defaultProps = {
  loadingMessage: ''
};export{LoadingPage as default};